import React, { useEffect, useState } from "react";
import { Form, Tab, Table, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiSearch } from "react-icons/bi";
import { Link } from "react-router-dom";
import ESGDataSetService from "../../../core/service/ESGDataSetService";
import './PlatformCodeMapping.scss';

const StdCodeSelectionPane = ({ t, platformCode, standardToMap, onCodeChange }) => {

	const [activeTab, setActiveTab] = useState('ENVIRONMENTAL');
	const [codes, setCodes] = useState([]);

	useEffect(() => {
		getCodes(standardToMap, activeTab, platformCode);
	}, [platformCode, standardToMap, activeTab]);

	const getCodes = (std, cat, platCode) => {
		if (!std || !cat || !platCode) return;

		ESGDataSetService.getPlatformStandardCodes(std, cat, platCode).then(res => {
			if (res.status !== 200) return;

			setCodes(res.data.data ?? []);
		}).catch(err => { });
	};

	const renderTabContent = () => {
		return (
			<div className="Standards_mapping_tabbox">
				<Table className="m-0">
					<tbody>
						{
							codes.map((code, index) => {
								return (
									<tr key={`code-${index}`}>
										<td>
											<input type="checkbox" 
											className="form-check-input"
												checked={code.alreadyMapped}
												onChange={(e) => {
													const c = JSON.parse(JSON.stringify(codes));
													c[index].alreadyMapped = !c[index].alreadyMapped;
													setCodes(c);
													const mappedCodes = [];
													c.forEach(c => {
														if (!c.alreadyMapped) return;

														mappedCodes.push(c.standardCode);
													});
													onCodeChange(mappedCodes);
												}}
											/>
										</td>
										<td>{code.standardCode}</td>
									</tr>
								);
							})
						}						
					</tbody>
				</Table>
			</div>
		);
	};

	return (
		<div className="card">
			<div className="SM_card_head">
				{standardToMap}
				<div className="SearchBox">
					<Form>
						<input
							type="text"
							className="form-control" />
						<Link to="#" className="Search_iocnBox">
							<BiSearch />
						</Link>
					</Form>
				</div>
			</div>
			<div className="SM_card_body">
				<Tabs
					id="controlled-tab-example"
					activeKey={activeTab}
					onSelect={(k) => setActiveTab(k)}
					className="Standards_mapping_tab">
					<Tab eventKey="ENVIRONMENTAL" title="Enivronmental">
						{renderTabContent()}
					</Tab>
					<Tab eventKey="SOCIAL" title="Social">
						{renderTabContent()}
					</Tab>
					<Tab eventKey="GOVERNANCE" title="Governance">
						{renderTabContent()}
					</Tab>
					<Tab eventKey="GENERAL_DISCLOSURE" title="General Disclosure">
						{renderTabContent()}
					</Tab>
				</Tabs>
			</div>
		</div>
	);
};
export default withTranslation()(StdCodeSelectionPane);
